import routes from "../../utils/constants/apiRoutes";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { createSlice, Dispatch } from '@reduxjs/toolkit'
import axios from "../../utils/axios";
import { searchParams } from "src/@types/data";

export function fetchAllNotifications(id: string, filters?: any, signal?: AbortSignal, orgCode?: string) {
    return async function getBookData() {
        try {
            const searchParams: searchParams = filters

            const queryString = "?" + new URLSearchParams(<URLSearchParams>searchParams).toString();
            const response = orgCode ? await axios.get(`${orgCode}${routes.NOTIFICATION}/${id}${queryString}`, { signal }) : await axios.get(`${routes.NOTIFICATION}/${id}${queryString}`, { signal });
            return response?.data;
        } catch (e) {
            console.log("error while fetchBookData", e);
        }
    };
}

export function updateNotificationById(id: string, read: boolean, orgCode?: string) {
    return async function updateNotificationById() {
        try {
            const response = orgCode ? await axios.patch(`${orgCode}${routes.NOTIFICATION}/update/${id}`, { read }) : await axios.patch(`${routes.NOTIFICATION}/update/${id}`, { read });
            return response?.data;
        } catch (e) {
            console.log("error while fetchBookData", e);
        }
    };
}

export function markAllNotificationAsRead(id: string, orgCode?: string) {
    return async function updateNotificationById() {
        try {
            const response = await axios.patch(orgCode ? `${orgCode}${routes.NOTIFICATION}/allRead/${id}` : `${routes.NOTIFICATION}/allRead/${id}`);
            return response?.data;
        } catch (e) {
            console.log("error while fetchBookData", e);
        }
    };
}

